import React from "react";
import styled from "styled-components";

import Container from "../components/layout/Container";
import PurposeTabs from "../components/estates/PurposeTabs";
import SearchBar from "../components/estates/SearchBar";
import EstateList from "../components/estates/EstateList";
import QuickFilter from "../components/estates/QuickFilter";

const Estates = () => {
  return (
    <Container
      navbarProps={{
        title: "Liste des Biens",
      }}
    >
      <StyleWrapper className="d-flex flex-column">
        <SearchBar />
        <div className="estates">
          <div className="d-flex align-items-center">
            <PurposeTabs />
            {/* <Button
              className="filter-btn"
              icon={<i className="bi bi-arrow-down-up" />}
            /> */}
          </div>
          <QuickFilter />
          <EstateList />
        </div>
      </StyleWrapper>
    </Container>
  );
};

const StyleWrapper = styled.div`
  .estates {
    margin-top: 12px;
  }

  .estate__tabs {
    flex-grow: 1;
  }

  .filter-btn {
    margin: 10px 15px 0 15px;
    padding: 6px 10px;
  }
`;

export default Estates;
